module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 考级测试")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "warning"
    }
  }, [_vm._v("\n      1.请根据自己的身份选择不同的考试类型"), _c('br'), _vm._v("\n      2.游客身份可以测试客观题，不可以测试实践题。"), _c('br'), _vm._v("\n      3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。"), _c('br')]), _vm._v(" "), _c('el-steps', {
    staticClass: "elsteps",
    attrs: {
      "space": 200,
      "active": 2,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "报名信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "理论测试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "实践考试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "考级结果"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "查看证书"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_content_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user.face
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.row.user.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_center"
  }, _vm._l((_vm.row.question_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "container_center_item"
    }, [_c('div', {
      staticClass: "container_center_item_title"
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('el-link', {
      staticClass: "container_center_item_link",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/coursecontent',
            query: {
              id: item.course_id,
              course_cate_id: 9,
            },
          })
        }
      }
    }, [_vm._v("查看相关教材")]), _vm._v(" "), (item.video.length > 0) ? _c('el-link', {
      staticClass: "container_center_item_link",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.seedemoFun(item.video)
        }
      }
    }, [_vm._v("查看示范")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      staticClass: "elbutton",
      attrs: {
        "type": "primary",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectQuestion(item)
        }
      }
    }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
      staticClass: "container_center_item_content html-data",
      domProps: {
        "innerHTML": _vm._s(item.desc_html)
      }
    })], 1)
  }), 0)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "示范视频",
      "visible": _vm.dialogVideoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVideoVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "video_wrap"
  }, [(_vm.dialogVideoVisible) ? _c('video', {
    ref: "myVideo",
    staticClass: "video_class",
    attrs: {
      "preload": "auto",
      "src": _vm.targetVideoSrc,
      "controls": "controls"
    }
  }) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe506346","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/kaoji/KaojiApplyStep4.vue
// module id = 1352
// module chunks = 0